import React, { useEffect, useState } from "react";
import Translate from "../components/Translate";
import { getPosts } from "../utils/networkApi";
import Loader from "../components/Loader";
import { useTranslation } from "react-i18next";
import { updateMetaTags } from "../utils/seo";
import PageBanner from "../components/PageBanner";

export default function AllarchivePage() {
  const { t, i18n } = useTranslation();
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    updateMetaTags(
      `${t('archives')} | ${t('site-title')}`,
      t('archives-desc'),
      t('archives-keywords')
    );
  }, [t, i18n.language]);
  const [oldData, setOldData] = useState([]);

  const [pagination, setPagination] = useState({});
  async function fetchData(page = 1) {
    try {
      setLoading(true);
      const savedLang = await localStorage.getItem("appLang") || "en";
      const response = await getPosts(`allArchive-api?lang=${savedLang}&page=${page}`)
      console.log(response.archive.data)
      setOldData(response.archive.data);
      setPagination({
        current_page: response.archive.current_page,
        last_page: response.archive.last_page,
      });
      setLoading(false);
    } catch (error) {
      setLoading(false);
      console.error('Error fetching data:', error);
    }
  }

  useEffect(() => {
    fetchData();
  }, [])

  return (
    <section className="w-full min-h-[80vh] bg-primary-50 pb-16">
      {loading && <Loader />}
      <PageBanner
        title={<Translate text="archive" />}
        subtitle={'"Access our comprehensive archive of past publications and announcements."'}
        badgeText="Extended Archive"
      />
      <div className="w-full max-w-7xl mx-auto px-4 mt-12">
        {/* Cards Grid */}

        <section className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4 mb-10">
          {oldData.map((job, idx) => (
            <article key={`${job.id}-${idx}`}
              className="bg-white rounded-2xl overflow-hidden shadow-sm hover:shadow-md transition flex flex-col justify-between" >

              <div className="relative w-full h-56">
                <img src={(job.image && typeof job.image === 'string' && job.image.trim() !== "") ? job.image : "/default.jpg"} alt={job.title}
                  className="w-full h-full object-cover" />
                {/* Date overlay badge */}
                <span className="absolute bottom-2 left-2 inline-flex items-center gap-1 px-2.5 py-1 rounded-full bg-black/50 backdrop-blur-sm text-white text-[11px] font-semibold">
                  <svg className="w-3 h-3 flex-shrink-0 opacity-80" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}><path strokeLinecap="round" strokeLinejoin="round" d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z" /></svg>
                  {job.date}
                </span>
              </div>

              <div className="p-1 flex-1">
                <h2 className="text-lg font-semibold text-primary-600 border-l-4 border-primary-400 pl-2 text-left">
                  {job.title} {job.id}
                </h2>
              </div>

              <div className="border-t border-gray-200 p-4 mt-auto">
                {/* Usage instruction */}
                <div className="flex items-start gap-1.5 px-2 py-1.5 rounded-md bg-amber-50 border border-amber-100 text-[10px] mb-3">
                  <svg className="w-3 h-3 text-amber-700 flex-shrink-0 mt-0.5" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}><path strokeLinecap="round" strokeLinejoin="round" d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" /></svg>
                  <span><span className="font-semibold text-amber-800 uppercase tracking-wide">{t('usage_label')}: </span><span className="text-amber-900">{t('pdf_viewer_instruction')}</span></span>
                </div>
                {/* Size + View PDF row */}
                <div className="flex items-center justify-between">
                  <span className="inline-flex items-center gap-1 px-2 py-0.5 rounded-md bg-gray-50 border border-gray-200 text-[10px]">
                    <svg className="w-3 h-3 text-gray-600 flex-shrink-0" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}><path strokeLinecap="round" strokeLinejoin="round" d="M4 7v10c0 2 1 3 3 3h10c2 0 3-1 3-3V7" /><path strokeLinecap="round" strokeLinejoin="round" d="M9 11h6M9 15h4" /></svg>
                    <span className="font-semibold text-gray-700 uppercase tracking-wide">{t('file_size_label')}:</span>
                    <span className="font-medium text-gray-700">{job.file_size || "~1–5 MB"}</span>
                  </span>
                  <a target="_blank" href={job.free_pdf}
                    className="inline-block text-sm font-medium px-3 py-1 rounded-full border border-primary-600 text-primary-600 hover:bg-primary-50 transition"
                    aria-label={`View PDF for ${job.title}`}
                    rel="noopener noreferrer">
                    View PDF
                  </a>
                </div>
              </div>
            </article>
          ))}

        </section>

        {/* ✅ View All Button */}
        <div className="d-flex justify-content-between">
          <button
            className="btn btn-primary"
            disabled={pagination.current_page === 1}
            onClick={() => fetchData(pagination.current_page - 1)}
          >
            Previous
          </button>

          <span>{` `}Page {pagination.current_page} of {pagination.last_page}</span>

          <button
            className="btn btn-primary"
            disabled={pagination.current_page === pagination.last_page}
            onClick={() => fetchData(pagination.current_page + 1)}
          >
            {` `}  Next
          </button>
        </div>



      </div>
    </section>
  );
}


